module.exports = __webpack_public_path__ + "img/cli_05.a40d363e.png";